import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import { setGlobalLoading } from 'redux/actions/actionCommon';
import { connect } from 'react-redux';
import LoadingSkeleton from '../../../LoadingSkeleton';

function Step1(props) {
    const { setGoSteps } = props
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
        }, 1000);
    }, [props.currentUser.token, props])
    return (
        <React.Fragment>
            <section id="app-product-filters" className="page-eorc-wrapper" style={{ position: "relative", top: "-46px" }}>
                <Container fluid className="st-container">
                    <div className="app-product-filters">
                        <Row className="product-filter-left-content">
                            <Col lg={9} md={12} className="product-filter-right-content">
                                {loading ? <LoadingSkeleton
                                    height={100}
                                /> :
                                    <div>
                                        <div className="app-card mb-3 mb-lg-4 add-criteria">
                                            <div className="product-filter-card">
                                                <div className="card-content">
                                                    <div className="d-flex align-items-center">
                                                        <div className="card-icon">
                                                            <span className="icon_ me-2">
                                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="56" height="56" focusable="false"><path fill="#336" d="M512 472c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V40C0 17.9 17.9 0 40 0h432c22.1 0 40 17.9 40 40v432z"></path><path fill="#FFF" d="M404 383.8l54.4-255.6H102.6L48.3 383.8z"></path><path fill="#336" d="M110 138.3s197.8 40.6 201.7 41.3c45.4 8 44 16.8 44 16.8 31.8-.2 35.8 1.1 41.3 5.8 16.7 14-10.5 55.2-10.5 55.2-3.9 2.9-298.2 116.5-298.2 116.5h307.9l50.3-236.7H110v1.1"></path><path fill="#336" d="M340.3 215c-4.5 2.2-16.1 3.4-21.6 3.9-5.3.4-6.7 1-6.8 3-.1 1.8.8 2.8 8.3 2.8 17.3 0 48.4-6.5 57.8-3.5 5 1.6 1 10.4-3.1 22-1.6 4.5 1.5 4.2 3.3 2.2 1.8-2 9.9-16.7 10.8-24.3 1.2-10.7-7.9-12.3-20.6-12.3h-20.1c-1.1 0-1.9.7-3.2 2.4-1 1.4-1.9 2.3-4.8 3.8"></path><path fill="#336" d="M98.6 191.9L60 373.9s118.4-58.1 132.8-65.5c29.7-15.2 70.7-35.4 108.6-48.3 7.2-2.5 38.2-12 56.2-15.2 7-1.3 9.9-2.4 9.9-3.8-.3-3.7-7.3-4-19.2-3.4-36.3 1.7-105.8 29.4-125.8 39.9l-22.6-70h144.4c6.5-18.2-85.5-15.6-88.3-15.8H98.6v.1"></path><path fill="#FFF" d="M463.7 355.5c0 10.8-8.5 19.3-19.5 19.3-10.9 0-19.7-8.5-19.7-19.3 0-10.6 8.7-19.1 19.7-19.1s19.5 8.5 19.5 19.1zm-34.3 0c0 8.5 6.3 15.2 14.9 15.2 8.4 0 14.5-6.7 14.5-15.1 0-8.5-6.2-15.4-14.7-15.4-8.4.1-14.7 6.9-14.7 15.3zm11.7 10h-4.4v-19.1c1.7-.3 4.2-.6 7.3-.6 3.6 0 5.2.6 6.6 1.4 1 .8 1.9 2.3 1.9 4.2 0 2.1-1.6 3.7-4 4.4v.2c1.9.7 2.9 2.1 3.5 4.7.6 2.9.9 4.1 1.4 4.8h-4.8c-.6-.7-.9-2.4-1.5-4.7-.3-2.1-1.5-3-4-3H441v7.7zm.2-10.8h2.1c2.4 0 4.4-.8 4.4-2.8 0-1.7-1.3-2.9-4.1-2.9-1.2 0-2 .1-2.4.2v5.5z"></path></svg>
                                                            </span>
                                                        </div>
                                                        <div className="card-text">
                                                            <div className="card-header_">
                                                                <span>U.S.P.C.</span>
                                                            </div>
                                                            <div className="card-description">
                                                                <div>Set up U.S.P.S. to enable up to 71 shipping methods.</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex">
                                                        <div>
                                                            <button
                                                                onClick={(e => {
                                                                    setGoSteps(1)
                                                                })}
                                                                type="button"
                                                                className="st-btn st-btn-primary st-fw-600 st-btn-xs text-capitalize d-flex align-items-center justify-content-center"
                                                            >
                                                                <span>set up U.P.S.C.</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>}
                            </Col>
                        </Row>
                    </div>
                </Container>
            </section>
        </React.Fragment>
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(Step1)